import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./Container.module.scss";

const Container = props => (
  <div className={classnames(styles.container, props.className)}>{props.children}</div>
);

Container.Row = props => (
  <div className={classnames(styles.row, props.className)}>{props.children}</div>
);

Container.propTypes = {
  className: PropTypes.string
};

Container.Row.propTypes = {
  className: PropTypes.string
};

export default Container;
